import SignUpHeader from '../SignUpPage/SignUpHeader.js';
import { VectorIcon } from '../SignUpPage/VectorIcon.tsx';
import { VectorIcon1 } from '../SignUpPage/VectorIcon1.tsx';
import { Alert } from 'react-bootstrap';
import ConfirmPassword from '../ConfirmPassword.js';
import Axios from 'axios';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import ErrorMessages from '../../errorConfig.js';
import { Link, useNavigate } from 'react-router-dom';
import PmsUrlConfig from '../../urlConfig.js';
import { useDispatch, useSelector } from 'react-redux';
import { setAuthToken } from '../common.js';

function ChangePassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginDetails = useSelector(state => state.loginDetails);
  const loggedInUser = loginDetails.loggedInUser;
  const token = loginDetails.jwtToken;
  var error = '';

  if (loginDetails != null) {
    error = loginDetails.loginError;
  }
  const passwordValidationSchema = Yup.object().shape({
    password: Yup.string()
      .when("passwordIsValid", {
        is: true,
        then: Yup.string().required('Required!'),
      })
      .min(8, ErrorMessages.PASSWORD_LENGTH),

    confPassword: Yup.string()
      .when("passwordIsValid", {
        is: true,
        then: Yup.string().required('Required!'),
      })
      .oneOf([Yup.ref('password')], ErrorMessages.PASSWORDS_DONT_MATCH),
  });
  return (
    <Formik
      initialValues={{
        password: '',
        confPassword: '',
      }}
      validationSchema={passwordValidationSchema}
      onSubmit={(values, { setSubmitting }) => {
        var editUserUrl = PmsUrlConfig.BOS_EDIT_PATIENT_PROFILE_URL;
        setAuthToken(token);
        Axios.patch(editUserUrl, {
          _id: loggedInUser._id,
          password: values.password,
          password_confirm: values.password,
        }
        ).then((response) => {
          if (response.status === 200) {
            dispatch({ type: 'editPasswordSuccess' });
            dispatch({
              type: 'resetSettings'
            })

            dispatch({
              type: 'loginSuccess',
              payload: null
            });
            navigate(`${PmsUrlConfig.LOGIN_URL}`, { state: { message: "Password changed successfully." } });
          }
          else if (response.status === 400) {

            if (response && response.data.error_code) {
              dispatch({
                type: 'error',
                payload: response.data.error_code.description
              });
            }

          }
          else if (response.status === 401 || response.status === 403) {

            // logout();
            //TODO: Redirect to login page
            if (response && response.data.error_code) {
              dispatch({
                type: 'error',
                payload: response.data.error_code.description
              });
            }
          }
        }).catch((error) => {
          console.log("step 333333")
          setSubmitting(false);
          console.log("-----------------", error)
          if (error.response && error.response.data.error_code) {
            dispatch({
              type: 'error',
              payload: error.response.data.error_code.description
            });
          }
          navigate(`${PmsUrlConfig.CHANGE_PASSWORD_URL}`, { state: { message: "" } });
        })

      }}
      onReset={(values) => {

      }}
    >
      {({ errors, touched, values, handleChange, isSubmitting, handleReset, handleBlur, setFieldValue }) => (
        <Form id="change-password-form">
          {/* Main container with responsive background */}
          <div className="w-full min-h-screen bg-gray-100">
            {/* Header */}
            <div className="fixed top-0 left-0 w-full h-[103px] bg-white border border-gray-200 shadow-sm z-10">
              <div className="w-full h-full">
                <SignUpHeader />
              </div>
            </div>

            {/* App name - responsive positioning */}
            <div className="relative top-12 lg:left-[35%] left-1/2 transform -translate-x-1/2 lg:translate-x-0 w-full max-w-[519px] h-20 flex items-center justify-center">
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 text-center leading-[80px] tracking-[-0.36px]">
                Practice Management System
              </h1>
            </div>

            {/* Main content area */}
            <div className="flex flex-col lg:flex-row min-h-screen pt-32 lg:pt-40">
              {/* Left vector icons - hidden on small screens */}
              <div className="hidden lg:block lg:w-1/6 relative">
                {/* Left vector */}
                <div className="fixed left-0 top-[10%] w-[278px] h-[324px] -translate-x-20 lg:-translate-x-24">
                  <VectorIcon1 className="w-full h-full" />
                </div>
              </div>

              {/* Main form content */}
              <div className="flex-1 lg:w-2/3 px-4 sm:px-6 lg:px-8">
                <div className="max-w-2xl mx-auto mt-8 lg:mt-16">
                  {/* Card */}
                  <div className="bg-white rounded-lg shadow-md border border-gray-200 mb-4">
                    {/* Header */}
                    <div className="border-b border-gray-200 px-6 py-4">
                      <h3 className="text-xl font-semibold text-gray-900">Change Password</h3>
                    </div>

                    {/* Error alert */}
                    {error && (
                      <div className="px-6 py-4">
                        <Alert variant="danger" className="mb-0">
                          {error}
                        </Alert>
                      </div>
                    )}

                    {/* Body */}
                    <div className="px-6 py-4">
                      <h6 className="text-base font-medium text-gray-700 mb-4">
                        Please enter the new password
                      </h6>
                      <div className="w-full">
                        <ConfirmPassword
                          errors={errors}
                          touched={touched}
                          handleBlur={handleBlur}
                        />
                      </div>
                    </div>

                    {/* Footer */}
                    <div className="border-t border-gray-200 px-6 py-4">
                      {/* Submit button */}
                      <div className="w-full max-w-[424px] mx-auto mb-4">
                        <button
                          type="submit"
                          disabled={isSubmitting}
                          className="w-full h-10 bg-[rgba(11,109,118,1)] hover:bg-[rgba(11,109,118,0.9)] text-white font-medium rounded-md shadow-sm transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          {isSubmitting ? 'Saving...' : 'Save'}
                        </button>
                      </div>

                      {/* Login link */}
                      <div className="w-full max-w-[424px] mx-auto text-center">
                        <p className="text-base text-gray-600">
                          <Link 
                            to={`${PmsUrlConfig.HOME_URL}`} 
                            className="font-semibold text-[rgba(11,109,118,1)] hover:text-[rgba(11,109,118,0.8)] transition-colors duration-200"
                          >
                            Login
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right vector icon - hidden on small screens */}
              <div className="hidden lg:block lg:w-1/6 relative">
                {/* Right vector */}
                <div className="fixed right-0 bottom-0 w-[395.9px] h-[315.78px] translate-x-20 lg:translate-x-24">
                  <VectorIcon className="w-full h-full" />
                </div>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>

  );
}

export default ChangePassword;